const surfaceGLSL = /* glsl */ `

/*
 * ============================================================
 * GENERIC SURFACE
 * ============================================================
 */

uniform vec3 uBaseColor;

uniform sampler2D uBaseTexture;
uniform bool uHasBaseTexture;

uniform sampler2D uAOMap;
uniform bool uHasAOMap;

uniform vec3 uEmissiveColor;

uniform sampler2D uEmissiveMap;
uniform bool uHasEmissiveMap;

uniform vec2 uTextureScale;
uniform float uTextureRotation;


/*
 * Transform the model's base UVs.
 */
vec2 transformSurfaceUv(
    vec2 uv
) {

    vec2 centered =
        uv -
        vec2(0.5);


    float cosine =
        cos(
            uTextureRotation
        );

    float sine =
        sin(
            uTextureRotation
        );


    mat2 rotation =
        mat2(
            cosine,
            -sine,
            sine,
            cosine
        );


    centered =
        rotation *
        centered;


    centered *=
        uTextureScale;


    return (
        centered +
        vec2(0.5)
    );
}


/*
 * Base color multiplied by the
 * optional albedo/base texture.
 */
vec3 getSurfaceColor(
    vec2 uv
) {

    vec3 color =
        uBaseColor;


    if (
        uHasBaseTexture
    ) {

        color *=
            texture2D(
                uBaseTexture,
                uv
            ).rgb;
    }


    return color;
}


/*
 * AO defaults to fully unoccluded.
 */
float getAmbientOcclusion(
    vec2 uv
) {

    if (
        !uHasAOMap
    ) {

        return 1.0;
    }


    return texture2D(
        uAOMap,
        uv
    ).r;
}


/*
 * Emission is independent of
 * external illumination.
 */
vec3 getEmissiveColor(
    vec2 uv
) {

    vec3 emissive =
        uEmissiveColor;


    if (
        uHasEmissiveMap
    ) {

        emissive *=
            texture2D(
                uEmissiveMap,
                uv
            ).rgb;
    }


    return emissive;
}

`;

export default surfaceGLSL;
